var map = {
	"./banhanguytin.png": "2725",
	"./cacung.png": "43db",
	"./chuyencan.png": "6f8f",
	"./daigiadataha.png": "56f2",
	"./duhanhgia.png": "af24",
	"./thanhsanma.png": "59ca",
	"./wow.png": "50f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1785";